import React from 'react';
import { useDispatch } from 'react-redux';

import { postColorballPlayerV2 } from '../../../actions/onboarding-actions';

import styles from '../nuoV2.scss';

const ColorBallPlayer = () => {
    const dispatch = useDispatch();

    const handleSubmit = (bool) => {
        const payload = {
            isColorBallPlayer: bool ? 1 : 0,
        };
        dispatch(postColorballPlayerV2(payload));
    };

    return (
        <div className={styles.pageContent}>
            <div className={styles.title} data-testid="nuo-v2.color-ball-player.title">
                Are you a color ball player?
            </div>
            <div className={styles.description} data-testid="nuo-v2.color-ball-player.description">
                Color ball is an enhanced experience for young players who play tennis using modified equipment such as green, orange, or red balls.
            </div>
            <div className="row mt16">
                <div className="col-12 col-md-6">
                    <button
                        type="button"
                        className="btn btn-primary btn-block btn-lg text-uppercase"
                        onClick={() => handleSubmit(false)}
                        data-testid="nuo-v2.color-ball-player.no-btn"
                    >
                        No
                    </button>
                </div>
                <div className="col-12 col-md-6">
                    <button
                        type="button"
                        className="btn btn-primary btn-block btn-lg text-uppercase"
                        onClick={() => handleSubmit(true)}
                        data-testid="nuo-v2.color-ball-player.yes-btn"
                    >
                        Yes
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ColorBallPlayer;
